<template>
  <div>
    <el-table :data="auditList">
      <el-table-column prop="userId" label="用户UID"></el-table-column>
<!--      <el-table-column prop="tel" label="账户手机"></el-table-column>-->
<!--      <el-table-column prop="email" label="账户邮箱"></el-table-column>-->
<!--      <el-table-column prop="countryName" label="国籍"></el-table-column>-->
      <el-table-column prop="realName" label="用户姓名"></el-table-column>
      <el-table-column prop="cardNo" label="证件号码"></el-table-column>
      <el-table-column label="证件照1">
        <template slot-scope="scope">
          <div v-if="scope.row.imgUrl!=null && scope.row.imgUrl!='' && scope.row.imgUrl.split(',').length>=1">
            <i class="el-icon-check"></i>
<!--            <img :src="scope.row.imgUrl.split(',')[0] " @click="picBig(scope.row.imgUrlsArr[0])" width="100" />-->
          </div>
          <!-- <el-button type="text" @click="picBig(scope.row.imgUrlsArr[0])">查看</el-button> -->
        </template>
      </el-table-column>
      <el-table-column label="证件照2">
        <template slot-scope="scope">
          <div v-if="scope.row.imgUrl!=null && scope.row.imgUrl!='' && scope.row.imgUrl.split(',').length>=2">
            <i class="el-icon-check"></i>

<!--            <img :src="scope.row.imgUrl.split(',')[1] " @click="picBig(scope.row.imgUrl.split(',')[1])" width="100" />-->
          </div>
<!--          <img :src="scope.row.imgUrlsArr[1]" @click="picBig(scope.row.imgUrlsArr[1])" width="100" />-->
          <!-- <el-button type="text" @click="picBig(scope.row.imgUrlsArr[1])">查看</el-button> -->
        </template>
      </el-table-column>
      <el-table-column label="证件照3">
        <template slot-scope="scope">
          <div v-if="scope.row.imgUrl!=null && scope.row.imgUrl!='' && scope.row.imgUrl.split(',').length>=3">
            <i class="el-icon-check"></i>

<!--            <img :src="scope.row.imgUrl.split(',')[2] " @click="picBig(scope.row.imgUrl.split(',')[2])" width="100" />-->
          </div>
<!--          <img :src="scope.row.imgUrlsArr[2]" @click="picBig(scope.row.imgUrlsArr[2])" width="100" />-->
          <!-- <el-button type="text" @click="picBig(scope.row.imgUrlsArr[2])">查看</el-button> -->
        </template>
      </el-table-column>
      <el-table-column label="状态">
        <template slot-scope="scope">
          <el-tag :type="scope.row.__status.color">{{scope.row.__status.text}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="backReason" label="备注"></el-table-column>
      <el-table-column label="提交时间">
        <template slot-scope="scope">
          {{scope.row.createTime | moment}}
        </template>
      </el-table-column>
      <el-table-column label="审核时间">
        <template slot-scope="scope">
          {{scope.row.auditTime | moment}}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <el-button type="primary" size="small" v-if="scope.row.status === 0 || scope.row.status === 2" @click="approveAudit(scope.row.id)">审核</el-button>
          <el-button type="success" size="small" v-if="scope.row.status !== 0 && scope.row.status !== 2" @click="approveAudit(scope.row.id)">查看</el-button>
          <el-button type="danger" size="small" v-if="scope.row.status === 0" @click="blackList(scope.row.id)">拉入黑名单</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination :size="pagination.size" :total="totalCount" :page="pagination.page" @pageChanged="pageChanged"></pagination>
    <audit-detail :value="auditId" @onUpdate="onUpdate"></audit-detail>
    <el-dialog title="查看图片" :visible.sync="picDialogVisible" width="30%" :before-close="handleClose">
      <img :src="this.nowPicUrl" width="100%" />
    </el-dialog>
    <!-- <el-dialog title="备注" :visible.sync="descVisible" width="30%">
      <div class="dialog-center">
        <el-input v-model="desc" placeholder="请输入备注信息" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="descVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="submitForm"
        >确 定</el-button>
      </span>
    </el-dialog> -->
  </div>
</template>

<script>
import Pagination from 'components/pagination';
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex';
import AuditDetail from '../detail';

export default {
  name: 'KYCAudit',
  data() {
    return {
      auditId: null,
      dialogVisible: false,
      descVisible: false,
      picDialogVisible: false,
      nowPicUrl: ''
    };
  },
  components: {
    Pagination,
    AuditDetail
  },
  methods: {
    ...mapMutations('kycAudit', ['toggleDetailDialogVisible', 'setPagination']),
    ...mapActions('kycAudit', ['list', 'approve']),
    approveAudit(id) {
      this.auditId = id;
      this.toggleDetailDialogVisible(true);
    },
    pageChanged(pagination) {
      this.$emit('refresh', pagination);
    },
    onUpdate() {
      this.$emit('refresh');
    },
    blackList(id) {
      this.$confirm('确认将此用户拉入黑名单吗？', '提示', {
        type: 'warning'
      }).then(() => {
        this.approve({ id, status: '-1' }).then(() => {
          this.$message({
            type: 'success',
            message: '操作成功！'
          });
          this.$emit('refresh');
        });
      });
    },
    picBig(picUrl) {
      if (!picUrl) {
        this.nowPicUrl = this.defaultPic;
        this.picDialogVisible = true;
        return;
      }
      this.nowPicUrl = picUrl;
      this.picDialogVisible = true;
    },
    handleClose() {
      this.picDialogVisible = false;
    }
  },
  computed: {
    ...mapGetters('kycAudit', ['auditList']),
    ...mapState('kycAudit', ['pagination', 'totalCount'])
  }
};
</script>

<style lang="less" scoped>
</style>
